import { render } from "./NotifyComponent.vue?vue&type=template&id=0beb6ad7&scoped=true"
import script from "./NotifyComponent.vue?vue&type=script&lang=js"
export * from "./NotifyComponent.vue?vue&type=script&lang=js"

import "./NotifyComponent.vue?vue&type=style&index=0&id=0beb6ad7&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0beb6ad7"]])

export default __exports__